import React, {Component} from 'react';

class Missing extends Component{
    render() {
        return (
            <div>
                Missing page
            </div>
        )
    }
}

export default Missing;